import React, { useEffect, useState } from 'react'
import Header from '../../Components/Header/Header'
import Footer from '../../Components/Footer/Footer'
import "../../Components/OrderComponents/Order.css"
import OrderDetail from "../../Components/OrderComponents/OrderDetail"
import OrderAddressDetails from "../../Components/OrderComponents/OrderAddressDetails"
import OrderHelp from "../../Components/OrderComponents/OrderHelp"
import { Apiurl, parseData, stringifyData,GetLocalStorageParsed, RemoveSession} from '../utils/page'
import axios from 'axios'
import Loader from '../../Components/Loader/Loader'
import { useNavigate } from 'react-router-dom'

const Orders = () => {
  const navigate=useNavigate();
  const FetchToken = GetLocalStorageParsed("AuthToken");

  useEffect(() => {
    window.scrollTo(0, 0);
    setPageNumber(0);

  }, []);
  const [activeButton, setActiveButton] = useState(1);
    const [totalRecord, setTotalRecord] = useState();
      const [numberOfRecordSelected, setNumberofRecordSelected] = useState();
    
  
  const [orderData, setOrderData] = useState();
  const [addNew, setAddNew] = useState(false);
    const [pageNumber, setPageNumber] = useState(0);
  
 

  const [loginToken, setLoginToken] = useState(FetchToken || null);
  const [loading,setLoading]=useState("");


  const GetOrders = (e, pagination, selected) => {
    if (pagination === "pag") {
      setPageNumber(e);
    }
    setLoading("order")
    const data = {};
    data.pageNumber =pagination === "pag" ? e + 1 : 1 || 1;
    data.pageSize = selected ||10 ;
    const option = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      data: stringifyData(data),
      url: `${Apiurl()}/api/Customer/OrderSummary`,
    };
    axios(option)
      .then((e) => {
        const data = parseData(e?.data?.result);
        setTotalRecord(e?.data?.totalRecords);
        if (e?.data?.totalRecords < 10) {
          setNumberofRecordSelected(10);
          setPageNumber(0);
        }

        setOrderData(data);
        setLoading("")


      })
      .catch((error) => { 
        // if (error?.code === "ERR_BAD_REQUEST") {
        //   RemoveSession(navigate);
        // }
      });
  };
  useEffect(() => {
    GetOrders();
  }, [])
  const handleNextPage = () => {
    GetOrders(pageNumber + 1, "pag");
  };
  const handlePrevPage = () => {
    GetOrders(pageNumber - 1, "pag");
  };
  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      {loading==="order"? 
      <div className="loading-container">
      <Loader />
    </div>
      :null}

      <Header setLoginToken={setLoginToken}/>
      <div className="banner_section" style={{ flex: "1" }}>
        <div>
          <div className="container">
            <div className="row">
              <div className="col-lg-12 mr-auto ml-auto mb_commn_pd_0">
                <div className="order-summery-section">
                  <h4 className="common_heading">
                    Order Details
                  </h4>
                  <hr className="mb-0" />
                  <div className="row">
                    <div className="col-lg-12">
                      <ul className="summery_list">
                        <li>
                          <button className={activeButton == 1 ? "active-btn" : "inactive-btn"} onClick={() => setActiveButton(1)}>
                            Order
                          </button>
                        </li>
                        <li>
                          <button className={activeButton == 2 ? "active-btn" : "inactive-btn"} onClick={() => setActiveButton(2)}>
                            Address
                          </button>
                        </li>
                        {/* <li>
                          <button className={activeButton == 3 ? "active-btn" : "inactive-btn"} onClick={() => setActiveButton(3)}>
                            Help
                          </button>
                        </li> */}
                      </ul>
                    </div>
                    <div className="col-lg-12">
                      {
                        activeButton == 1 ? <OrderDetail orderData={orderData} GetOrders={GetOrders} loading={loading}
                        handlePrevPage={handlePrevPage} handleNextPage={handleNextPage}
                        pageNumber={pageNumber} setPageNumber={setPageNumber}
        totalRecord={totalRecord}
        setNumberofRecordSelected={setNumberofRecordSelected}
        numberOfRecordSelected={numberOfRecordSelected}


                        /> : activeButton == 2 ? <OrderAddressDetails setAddNew={setAddNew} addNew={addNew} /> : activeButton == 3 ? <OrderHelp /> : null
                      }

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
          </div>
        </div>
      </div>
      <Footer />

    </div>
  )
}

export default Orders
